'use client';

import { Button, Group, Modal, rem, Text } from '@mantine/core';
import { authLocales, createTranslations, type Locales } from '../locales';
import { actionsLocales } from '../locales/actions';

const ConfirmResetPasscodeModal = ({
  opened,
  onClose,
  mobile,
  onConfirm,
  lang = 'vi',
}: {
  opened: boolean;
  onClose: () => void;
  mobile: string;
  onConfirm: (mobile: string) => void;
  lang?: keyof Locales;
}) => {
  const tAuth = createTranslations({ locales: authLocales, lang });
  const tActions = createTranslations({ locales: actionsLocales, lang });
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      size={rem(343)}
      centered
      title={tAuth('resetYourPassword')}
      withCloseButton={false}
      closeOnClickOutside={false}
      closeOnEscape={false}
      styles={{
        header: {
          paddingBottom: rem(12),
        },
        title: {
          fontSize: rem(18),
          lineHeight: rem(24),
          color: 'var(--mantine-color-neutral-9)',
        },
        body: {
          fontSize: rem(16),
          lineHeight: rem(24),
          fontWeight: 500,
          color: 'var(--mantine-color-neutral-6)',
          whiteSpace: 'pre-line',
        },
        overlay: {
          zIndex: 1500,
        },
        inner: {
          zIndex: 1500,
        },
      }}
    >
      <Text size="sm" fw={500} c="neutral.6" mt={rem(-4)}>
        {tAuth('forgotPasswordDesc')}
      </Text>
      <Group
        gap={rem(16)}
        mt="lg"
        style={{
          flexDirection: 'column-reverse',
        }}
      >
        <Button
          fullWidth
          h={rem(48)}
          variant="light"
          color="neutral"
          onClick={onClose}
          fw={700}
          c="secondary.7"
        >
          {tActions('cancel')}
        </Button>
        <Button
          fullWidth
          h={rem(48)}
          fw={700}
          onClick={() => {
            onClose();
            onConfirm(mobile);
          }}
        >
          {tAuth('getPasswordResetLink')}
        </Button>
      </Group>
    </Modal>
  );
};
export default ConfirmResetPasscodeModal;
